import cookie from 'react-cookie';

class Onboarding {
  static init() {
    const existingUser = cookie.load('header-clicked');

    this._headersUnderstood =
      existingUser || cookie.load('onboarding-header-clicked');
    this._headersClickedOnce =
      existingUser ||
      this._headersUnderstood ||
      cookie.load('onboarding-header-clicked-once');
    this._editClicked = existingUser || cookie.load('onboarding-edit-clicked');
    this._disableClicked =
      existingUser || cookie.load('onboarding-disable-clicked');
    this._drilldownClicked =
      existingUser || cookie.load('onboarding-drilldown-clicked');

    this._suggestionsClicked = cookie.load('onboarding-suggestions-clicked');

    this._welcomeHidden = cookie.load('onboarding-welcome-hidden');

    this._initialised = true;
  }

  static showWelcome() {
    return !this._welcomeHidden;
  }

  static hideWelcome() {
    this.setCookie('onboarding-welcome-hidden');
  }

  static suggestionsAlreadyClicked() {
    return this._suggestionsClicked;
  }

  static showHeaderOnboarding() {
    return (
      !this._headersClickedThisSession &&
      !this._headersUnderstood &&
      this._initialised
    );
  }

  static showEditLayerOnboarding() {
    return false; // this._headersUnderstood && !this._editClicked;
  }

  static showDisableLayerOnboarding() {
    return this._headersUnderstood && !this._disableClicked;
  }

  static showDrilldownOnboarding() {
    return (
      this._headersUnderstood && this._disableClicked && !this._drilldownClicked
    );
  }

  static suggestionsClicked() {
    if (!this._suggestionsClicked) {
      this.setCookie('onboarding-suggestions-clicked');
      this._suggestionsClicked = true;
    }
  }

  static headerClicked() {
    this._headersClickedThisSession = true;
    if (!this._headersClickedOnce) {
      this.setCookie('onboarding-header-clicked-once');
      // this._headersClickedOnce = true;
    } else if (!this._headersUnderstood) {
      // assume that they get it
      this.headerUnderstood();
    }
  }

  static headerUnderstood() {
    if (!this._headersUnderstood) {
      this.setCookie('onboarding-header-clicked');
      this._headersUnderstood = true;
    }
  }

  static buttonClicked(onboarding) {
    switch (onboarding) {
      case 'edit':
        this._editClicked = true;
        this.setCookie('onboarding-edit-clicked');
        break;
      case 'disable':
        this._disableClicked = true;
        this.setCookie('onboarding-disable-clicked');
        break;
      case 'drilldown':
        this._drilldownClicked = true;
        this.setCookie('onboarding-drilldown-clicked');
        break;
    }
  }

  static setCookie(key) {
    cookie.save(key, true, {
      path: '/',
      maxAge: 60 * 60 * 24 * 31 * 12 /* 1 year */,
    });
  }
}

export default Onboarding;
